<template>
	<ul role="navigation" class="pagination">
		<li class="page-item" :class="[paginator.currentPage === 1 ? 'disabled '  : ' ']">
			<a v-if="paginator.currentPage > 1" :href="paginator.urls[paginator.currentPage - 1]" class="page-link">‹</a>
			<span v-else class="page-link">‹</span>
		</li>
		<li class="page-item" v-for="(url, index) in paginator.urls" :class="[index == paginator.currentPage ? 'active '  : ' ']">
			<span v-if="paginator.currentPage > 3 && index == 2" class="page-link">...</span>

			<span v-if="paginator.currentPage < Object.keys(paginator.urls).length - 3 && index == Object.keys(paginator.urls).length - 1" class="page-link">...</span>

			<span v-if="index == paginator.currentPage" class="page-link">{{ index }}</span>
			<a v-else-if="index == 1 || index == paginator.currentPage + 1 || index == paginator.currentPage + 2 || index == paginator.currentPage - 1 || index == Object.keys(paginator.urls).length" :href="url" class="page-link">{{ index }}</a>
		</li>
		<li class="page-item" :class="[paginator.currentPage == Object.keys(paginator.urls).length ? 'disabled '  : ' ']">
			<a v-if="paginator.currentPage < Object.keys(paginator.urls).length" :href="paginator.urls[paginator.currentPage + 1]" class="page-link">›</a>
			<span v-else class="page-link">›</span>
		</li>
	</ul>
</template>

<script>
	export default {
		name: 'Paginator',
		props: {
			dataPaginator: {
				type: Object
			}
		},
		data() {
			return {
				paginator: this.dataPaginator
			}
		}
	}
</script>

<style scoped>

</style>
